import React from 'react';
import * as S from './styled';
export const EventsSection = ({ title, button, emptyMessage, children }) => {
    return (React.createElement("div", null,
        React.createElement(S.Header, null,
            React.createElement(S.Title, null, title),
            React.createElement("div", null, button)),
        React.createElement(S.Content, { maxHeight: 220 }, emptyMessage ? React.createElement(S.EmptyMessage, null, emptyMessage) : children)));
};
